export default __webpack_public_path__ + "static/media/7.47820a6b.jpg";